import { render, staticRenderFns } from "./CustomIdentifierManager.vue?vue&type=template&id=a394661c&scoped=true"
import script from "./CustomIdentifierManager.vue?vue&type=script&lang=js"
export * from "./CustomIdentifierManager.vue?vue&type=script&lang=js"
import style0 from "./CustomIdentifierManager.vue?vue&type=style&index=0&id=a394661c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a394661c",
  null
  
)

export default component.exports